import React from "react";
import { useEffect, useState,useContext } from "react";
import useFetch from "../../hooks/useFetch";
import styles from "./TopicsOnAgenda.module.sass";
import { GlobalContext } from "../../GlobalContext";

export default function TopicsOnAgenda({ isNews }) {
  const { prevAgenda } = useContext(GlobalContext);
  const [agendaDay, setagendaDay] = useState(null);
  const [Agendas, setAgenda] = useState([]);
  const { data: agenda } = useFetch("agenda");
  const [NewAgenda, setNewAgenda] = useState(null);

  useEffect(() => {
    let tempAgenda = [];
    let count = 0;
    agenda && agenda?.map((v, i) => {
      console.log(v,"vvvv");
      
      if (v.status === "day") {
        setAgenda((prevAgenda) => [...prevAgenda, v.heading]); // Assuming agenda should be an array
      }

      if (v.status === "speaker" && v.speaker?.length > 0 && count < 3) {
        // console.log("agenda-----", v);
        tempAgenda.push(v);
        count++;
      } else if (v?.status === "day") {
        setagendaDay(v?.heading);
      }
    });
    setNewAgenda(tempAgenda);
  }, [agenda]);
  return (
    <div
      className={styles.container}
      // style={isNews ? { backgroundColor: "rgba(241, 241, 241, 1)" } : null}
    >
      {NewAgenda && NewAgenda?.length > 0 ? (
        <div className={styles.agendaContainer}>
          <div>
            <h1>topics on the agenda</h1>
            <div className={styles.cardContainer}>
              {NewAgenda &&
                NewAgenda?.map((v, i) => {
                  return (
                    <div
                      className={styles.card}
                      // style={isNews ? { backgroundColor: "#fff" } : null}
                    >
                      <p
                        dangerouslySetInnerHTML={{
                          __html: v?.heading,
                        }}
                      ></p>
                      <div>
                        {/* <p>{agendaDay}</p> */}
                        <p>
                        {v?.dayid === "1"
                            ? prevAgenda == "false"
                              ? `Day 1: ${Agendas[0]}`
                              : "Day 1"
                            : v?.dayid === "2"
                            ? prevAgenda == "false"
                              ? `Day 2: ${Agendas[1]}`
                              : "Day 2"
                            : ""}
                        </p>

                        <p>{`${v?.start_time} - ${v?.end_time}`}</p>
                      </div>
                    </div>
                  );
                })}
            </div>
            <button onClick={() => navigate("/agenda-page")}>
              view more topics
            </button>
          </div>
        </div>
      ) : null}
    </div>
  );
}
